import { DashboardCard } from "./DashboardCard"
import type { DashboardStageSection } from "./dashboardData"
import { sectionTitleId } from "./sectionTitleId"

type StageSectionProps = {
  dashboardDate: string
  section: DashboardStageSection
}

export function StageSection({ dashboardDate, section }: StageSectionProps) {
  const titleId = sectionTitleId(section.title)
  const partyCount = section.cards.length

  return (
    <section aria-labelledby={titleId}>
      <div className="mb-4 flex items-baseline gap-2.5">
        <h2 className="text-2xl font-bold leading-[29px]" id={titleId}>
          {section.title}
        </h2>
        <span className="text-sm font-medium leading-[17px] text-[#7e7e7e]">
          {partyCount} {partyCount === 1 ? "party" : "parties"}
        </span>
      </div>

      {section.cards.length ? (
        <div className="grid grid-cols-3 gap-3.5 max-[1100px]:grid-cols-2 max-[720px]:grid-cols-1">
          {section.cards.map((card) => (
            <a
              aria-label={`Open ${card.party_name} stay details`}
              className="block h-full min-w-0 rounded transition duration-150 hover:-translate-y-0.5 hover:shadow-[0_10px_24px_rgba(44,52,65,0.12)] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#337ab7] focus-visible:ring-offset-2"
              href={card.url}
              key={card.id}
            >
              <DashboardCard card={card} dashboardDate={dashboardDate} />
            </a>
          ))}
        </div>
      ) : null}
    </section>
  )
}
